<template>
    <main class="register-confirm">
        <div class="container">
            <Header :title="userFastMsg.title" :text="userFastMsg.text" />
            <CardMessage
                :title="userFastMsg.titleMsg"
                :message="userFastMsg.message"
                :info="userFastMsg.info"
                :confirmIcon="userFastMsg.confirmIcon"
            />
        </div>
    </main>
</template>

<script>
import CardMessage from "@/components/signupAndLogin/CardMessage";
import Header from "@/components/signupAndLogin/Header";
import router from "@/router";
import { getSession } from "@/utils/auth";
import { BASIC, ESSENTIAL } from "@/utils/clientTypes";
import { mapActions, mapState } from "vuex";

export default {
    name: "Confirm",
    components: {
        Header,
        CardMessage,
    },
    computed: {
        ...mapState("userAuth", ["user", "hasSIIAutomation"]),
        userFastMsg: function() {
            let isUserFast = this.$route.params.isUserFast === true;
            let session = getSession();
            if (isUserFast && session && this.user.client_type == BASIC) {
                return {
                    title: "¡ESTÁS LISTO PARA GENERAR EL REPORTE!",
                    text: "",
                    titleMsg:
                        "En los proximos dias seguiremos los siguientes pasos:",
                    message:
                        "<ol style='list-style-type: inherit'>" +
                        "<li>Recopilaremos tus datos del sii</li>" +
                        "<li>Armaremos el reporte para mostrarlo en unos dias</li>" +
                        "</ol></br>" +
                        "¡NOS VEMOS!",
                    info:
                        "Para cualquier consulta o dudas escríbenos a " +
                        "customersuccess@cforemoto.com",
                    confirmIcon: false,
                };
            } else if (
                isUserFast &&
                session &&
                this.user.client_type == ESSENTIAL
            ) {
                return {
                    title: "¡ESTÁS LISTO PARA EL KICK-OFF!",
                    text: "",
                    titleMsg: "En la reunión seguiremos los siguientes pasos:",
                    message:
                        "<ol style='list-style-type: inherit'>" +
                        "<li>Nos contarás sobre tu negocio.</li>" +
                        "<li>Definiremos tus líneas de negocio.</li>" +
                        "<li>Te capacitaremos para que puedas enviar data " +
                        "que no podemos capturar de forma automática." +
                        "</li>" +
                        "<li>Te contaremos sobre lo que viene para que " +
                        "puedas recibir tu primer reporte.</li>" +
                        "</ol></br>" +
                        "¡NOS VEMOS!",
                    info:
                        "Para cualquier consulta o dudas escríbenos a " +
                        "customersuccess@cforemoto.com",
                    confirmIcon: false,
                };
            } else {
                return {
                    title: "¡Bienvenido!",
                    text:
                        "A la plataforma para gestionar y planificar el " +
                        "flujo de caja de tu negocio.",
                    titleMsg: "Solicitud Enviada",
                    message:
                        "Hemos enviado a tu correo un mensaje de " +
                        "confirmación de registro.",
                    info:
                        "Si no se visualiza el correo en tu casilla de " +
                        "entrada revisa en tu carpeta de spam.",
                    confirmIcon: true,
                };
            }
        },
    },
    methods: {
        ...mapActions("userAuth", ["clearUserInfo"]),
    },
    destroyed() {
        if (this.$route.params.isUserFast === true) {
            this.clearUserInfo();
            router.push("/");
        }
    },
};
</script>
